import React, { useEffect, useState } from "react";
import axios from 'axios'; // Import Axios
import { Link } from "react-router-dom"; // Import Link for navigation
import Particles from "react-tsparticles";
import ParticlesBackground from "../../common/bgparticals";

function OurteamContent() {
  const [team, setTeam] = useState([]);
  const [error, setError] = useState(null); // State to hold error messages

  useEffect(() => {
    const fetchTeam = async () => {
      try {
        const response = await axios.get('https://tita.itrain.io/team/getAllTeam'); // Fetch team data from API
        console.log("Fetched team data:", response.data); // Log the fetched data
        if (response.data && response.data.success) {
          console.log("Team data:", response.data.data); // Log the team data
          setTeam(response.data.data || []); // Set the team state with the team array or an empty array if undefined
        } else {
          setError("Failed to fetch team data. Please try again later."); // Handle case where success is false
        }
      } catch (error) {
        console.error("Error fetching team data:", error.response ? error.response.data : error.message); // Log detailed error
        setError("Failed to fetch team data. Please try again later."); // Set error message
      }
    };

    fetchTeam();
  }, []);

  if (error) {
    return <div className="error-message">{error}</div>; // Display error message if there is an error
  }

  // Sort team members based on sno
  const sortedTeam = team.sort((a, b) => a.sno - b.sno);

  return (
    <section className="team-section padding">
      <ParticlesBackground></ParticlesBackground>
      <div className="container">
        <div className="row gy-lg-0 gy-4 justify-content-center">
          {sortedTeam && 
            sortedTeam.filter(member => member.sno < 3).map((member, index) => ( // Filter members with sno less than 2
              <div className="col-lg-3 col-md-6 justify-center" key={member._id}>
                <div className="team-item wow fade-in-bottom mb-4" data-wow-delay={`${100 * (index % 4)}ms`}>
                  <div className="team-thumb">
                    <Link to={`/team-detail?id=${member._id}`}> 
                      <img src={member.Image ? member.Image : 'fallback-image-url.jpg'} alt="thumb" /> 
                    </Link>
                    <ul className="team-social">
                      <li><a href={member.facebook.startsWith("http") ? member.whatsapp : `https://wa.me/${member.facebook.replace(/[^\d]/g, "")}`}
                        target="_blank"
                        rel="noopener noreferrer"><i className="fa-brands fa-whatsapp" /></a></li>
                      <li><a
                        href={member.linkedin.startsWith("http") ? member.linkedin : `https://${member.linkedin}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      ><i className="fa-brands fa-linkedin" /></a></li> {/* Updated LinkedIn icon */}
                    </ul>
                  </div>
                  <Link to={`/team-detail?id=${member._id}`}>
                    <div className="team-content">
                      <h4 className="position">{member.Position}</h4>
                      <h3>{member.Name}</h3> {/* Navigate to team detail page */}
                    </div>
                  </Link>
                </div>
              </div>
            ))
         }
        </div>
        <br />
        <br />
        <div className="row gy-lg-0 gy-4 justify-content-center">
          <div className="col-lg-12">
            <h2>Our Expert Team</h2>
          </div>
          <br />
          <br />
          {sortedTeam.filter(member => member.sno > 2).map((member, index) => (
            <div className="col-lg-4 col-md-6" key={member._id}>
              <div className="team-item wow fade-in-bottom mb-4" data-wow-delay={`${100 * (index % 4)}ms`}>
                <div className="team-thumb">
                  <Link to={`/team-detail?id=${member._id}`}>  
                    <img src={member.Image ? member.Image : 'fallback-image-url.jpg'} alt="thumb" />
                  </Link>
                  <ul className="team-social">
                    {(member.Name === "DivyaBharathi N" || member.Name === "Shyam Sundar Moorthy") && (
                      <li><a href={member.facebook.startsWith("http") ? member.whatsapp : `https://wa.me/${member.facebook.replace(/[^\d]/g, "")}`}
                      target="_blank"
                      rel="noopener noreferrer"><i className="fa-brands fa-whatsapp" /></a></li>
                    )}

                    <li><a
                      href={member.linkedin.startsWith("http") ? member.linkedin : `https://${member.linkedin}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    ><i className="fa-brands fa-linkedin" /></a></li> {/* Updated LinkedIn icon */}
                  </ul>
                </div>
                <Link to={`/team-detail?id=${member._id}`}>
                  <div className="team-content">
                    <h4 className="position">{member.Position}</h4>
                    <h3>{member.Name}</h3>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OurteamContent;
